import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    status: 'disconnected', // 'disconnected' | 'connecting' | 'connected' | 'error'
    error: null,
    activeGroupId: null, // cash register id used as group identifier
}

export const pubsubSlice = createSlice({
    name: 'pubsub',
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload
            if (action.payload !== 'error') state.error = null
        },
        setError: (state, action) => {
            state.status = 'error'
            state.error = action.payload
        },
        setActiveGroupId: (state, action) => {
            state.activeGroupId = action.payload
        },
        clearActiveGroupId: state => {
            state.activeGroupId = null
        },
    },
})

export const pubsubActions = {
    ...pubsubSlice.actions,
}

export default pubsubSlice.reducer
